/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

import Loader from '@/components/commons/loader';
import Title from '@/components/commons/page-elements/Title';

import ContactMappingWithoutFetch from '@/components/commons/ContactMapping/renderWithoutFetch';
import Statistics from './circles/Statistics';
import MySixtyNav from './Nav';
// import Highlights from './circles/Highlights';
import { /* highlights, */ navData } from './MockedData';
import ContactsGame from './contacts-game';

export interface UnifiedContactStats {
    0?: number;
    1?: number;
    2?: number;
    newContacts?: number;
}

interface Props {
    readonly setSidePanelOpen: (open: boolean) => void;
    readonly loading: boolean;
    readonly error: boolean;
    readonly statistics: UnifiedContactStats;
    readonly contacts: any;
}

function MySixtyDashboard({
    setSidePanelOpen,
    loading,
    error,
    statistics,
    contacts,
}: Props) {
    const [selected, setSelected] = useState(navData[0].value || '');

    useEffect(() => {
        if (selected === 'contacts-game') {
            setSidePanelOpen(false);
        }
    }, [selected]);

    return (
        <div className="">
            <div className="pr-6 mb-10">
                <Title
                    title="My Sixty"
                    subtitle="View the current state of your network and engage with the most valuable contacts."
                    bold
                />
            </div>
            <MySixtyNav data={navData} setSelected={setSelected} selected={selected} />
            {selected === 'circles' && (
                <div className="flex flex-col md:flex-row items-start md:items-center justify-start">
                    <div className="flex flex-col items-start justify-center mr-0 md:mr-20">
                        <Loader isLoading={loading} isError={error}>
                            <Statistics data={statistics} />
                            {/* <Highlights data={highlights} /> */}
                        </Loader>
                    </div>
                    <div className="hidden lg:block">
                        <ContactMappingWithoutFetch contacts={contacts} width={800} />
                    </div>
                    <div className="hidden md:block lg:hidden">
                        <ContactMappingWithoutFetch contacts={contacts} width={400} />
                    </div>
                    <div className="block md:hidden">
                        <ContactMappingWithoutFetch contacts={contacts} width={250} />
                    </div>
                </div>
            )}
            {selected === 'contacts-game' && (
                <div className="pt-4">
                    <ContactsGame />
                </div>
            )}
        </div>
    );
}

export default MySixtyDashboard;
